import { render, staticRenderFns } from "./crearMillonario.vue?vue&type=template&id=6180fed2&scoped=true"
import script from "./crearMillonario.vue?vue&type=script&lang=js"
export * from "./crearMillonario.vue?vue&type=script&lang=js"
import style0 from "./crearMillonario.vue?vue&type=style&index=0&id=6180fed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180fed2",
  null
  
)

export default component.exports